(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ra-featured-collection-tabs"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initCollectionTabs(container) {
    if (container.dataset.tabsReady === 'true') return;

    var tabs = container.querySelectorAll('[role="tab"]');
    var panels = container.querySelectorAll('[role="tabpanel"]');

    if (!tabs.length || !panels.length) return;

    container.dataset.tabsReady = 'true';

    function activateTab(index) {
      tabs.forEach(function(tab, i) {
        var isActive = i === index;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach(function(panel, i) {
        var isActive = i === index;
        panel.setAttribute('data-active', isActive ? 'true' : 'false');

        if (isActive) {
          var tpl = panel.querySelector('template[data-deferred-panel]');
          if (tpl) {
            panel.appendChild(tpl.content.cloneNode(true));
            tpl.remove();
          }
        }
      });
    }

    tabs.forEach(function(tab, i) {
      tab.addEventListener('click', function() {
        activateTab(i);
        this.focus();
      });

      tab.addEventListener('keydown', function(e) {
        var idx = parseInt(this.getAttribute('data-tab-index'), 10);
        var len = tabs.length;
        var newIdx = -1;

        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          newIdx = (idx + 1) % len;
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          newIdx = (idx - 1 + len) % len;
        } else if (e.key === 'Home') {
          e.preventDefault();
          newIdx = 0;
        } else if (e.key === 'End') {
          e.preventDefault();
          newIdx = len - 1;
        }

        if (newIdx >= 0) {
          activateTab(newIdx);
          tabs[newIdx].focus();
        }
      });
    });
  }

  document.querySelectorAll('[id^="ra-collection-tabs-"]').forEach(initCollectionTabs);

  document.addEventListener('shopify:section:load', function(event) {
    event.target.querySelectorAll('[id^="ra-collection-tabs-"]').forEach(initCollectionTabs);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ra-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
	  (function () {
	    function getCookie(name) {
	      var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
	      return match ? match[2] : null;
	    }

    function setCookie(name, value, days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 86400000);
	      document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
	    }

	    function initPopup(dialog) {
	      if (dialog.dataset.raPopupReady === 'true') return;

	      var sectionId = dialog.getAttribute('data-ra-popup-id');
	      var delayMs = parseInt(dialog.getAttribute('data-ra-popup-delay-ms'), 10) || 0;
	      var cookieDays = parseInt(dialog.getAttribute('data-ra-popup-cookie-days'), 10) || 30;
	      var cookieName = 'ra_popup_dismissed_' + sectionId;
	      var closeBtn = dialog.querySelector('[data-ra-popup-close="' + sectionId + '"]');
	      var dismissBtn = dialog.querySelector('[data-ra-popup-dismiss="' + sectionId + '"]');
	      var form = dialog.querySelector('form');

	      if (!sectionId) return;
	      dialog.dataset.raPopupReady = 'true';

	      if (getCookie(cookieName) === '1') return;

	      function dismiss() {
	        dialog.close();
	        setCookie(cookieName, '1', cookieDays);
	      }

	      if (closeBtn) closeBtn.addEventListener('click', dismiss);
	      if (dismissBtn) dismissBtn.addEventListener('click', dismiss);

	      dialog.addEventListener('click', function (e) {
	        if (e.target === dialog) dismiss();
	      });

	      dialog.addEventListener('cancel', function () {
	        setCookie(cookieName, '1', cookieDays);
	      });

	      if (form) {
	        form.addEventListener('submit', function () {
	          setCookie(cookieName, '1', cookieDays);
	        });
	      }

	      var timer = setTimeout(function () {
	        if (getCookie(cookieName) === '1') return;
	        if (window.Shopify && window.Shopify.designMode) return;

	        dialog.showModal();
	        if (closeBtn) closeBtn.focus();
	      }, delayMs);

	      if (window.Shopify && window.Shopify.designMode) {
	        document.addEventListener('shopify:section:unload', function (e) {
	          if (e.detail.sectionId === sectionId) {
	            clearTimeout(timer);
	            if (dialog.open) dialog.close();
	          }
	        });

	        document.addEventListener('shopify:section:select', function (e) {
	          if (e.detail.sectionId === sectionId && !dialog.open) {
	            dialog.showModal();
	          }
	        });

	        document.addEventListener('shopify:section:deselect', function (e) {
	          if (e.detail.sectionId === sectionId && dialog.open) {
	            dialog.close();
	          }
	        });
	      }
	    }

	    document.querySelectorAll('.ra-popup[data-ra-popup-id]').forEach(initPopup);

	    document.addEventListener('shopify:section:load', function(event) {
	      event.target.querySelectorAll('.ra-popup[data-ra-popup-id]').forEach(initPopup);
	    });
	  })();
	
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ra-pdp-hero-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initVideo = (frame) => {
      if (frame.dataset.raPdpHeroVideoReady === 'true') return;

      const playButton = frame.querySelector('[data-ra-pdp-hero-video-play]');
      const template = frame.querySelector('template[data-ra-pdp-hero-video-template]');

      if (!playButton || !template) return;

      frame.dataset.raPdpHeroVideoReady = 'true';

      playButton.addEventListener('click', () => {
        if (frame.dataset.playing === 'true') return;

        frame.appendChild(template.content.cloneNode(true));
        frame.dataset.playing = 'true';

        const video = frame.querySelector('video');
        if (video) {
          video.play().catch(() => {});
          video.focus({ preventScroll: true });
          return;
        }

        const iframe = frame.querySelector('iframe');
        if (iframe) iframe.focus({ preventScroll: true });
      });
    };

    document.querySelectorAll('[data-ra-pdp-hero-video]').forEach(initVideo);

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-ra-pdp-hero-video]').forEach(initVideo);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ra-products-in-action"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initActionVideo = (frame) => {
      if (frame.dataset.raProductsActionReady === 'true') return;

      const playButton = frame.querySelector('[data-ra-products-action-play]');
      const template = frame.querySelector('template[data-ra-products-action-template]');

      if (!playButton || !template) return;

      frame.dataset.raProductsActionReady = 'true';

      playButton.addEventListener('click', () => {
        if (frame.dataset.playing === 'true') return;

        frame.appendChild(template.content.cloneNode(true));
        frame.dataset.playing = 'true';

        const video = frame.querySelector('video');
        if (video) {
          video.play().catch(() => {});
          video.focus({ preventScroll: true });
          return;
        }

        const iframe = frame.querySelector('iframe');
        if (iframe) iframe.focus({ preventScroll: true });
      });
    };

    document.querySelectorAll('[data-ra-products-action-video]').forEach(initActionVideo);

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-ra-products-action-video]').forEach(initActionVideo);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ra-size-guide"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initSizeGuide(openBtn) {
    if (openBtn.dataset.sizeGuideReady === 'true') return;

    var sectionId = openBtn.getAttribute('data-size-guide-open');
    var dialog = document.getElementById('ra-size-guide-dialog-' + sectionId);
    if (!dialog) return;

    var closeBtn = dialog.querySelector('[data-size-guide-close="' + sectionId + '"]');

    openBtn.dataset.sizeGuideReady = 'true';

    openBtn.addEventListener('click', function() {
      dialog.showModal();
      if (closeBtn) closeBtn.focus();
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        dialog.close();
        openBtn.focus();
      });
    }

    dialog.addEventListener('click', function(event) {
      if (event.target === dialog) {
        dialog.close();
        openBtn.focus();
      }
    });

    dialog.addEventListener('cancel', function() {
      openBtn.focus();
    });
  }

  document.querySelectorAll('[data-size-guide-open]').forEach(initSizeGuide);

  document.addEventListener('shopify:section:load', function(event) {
    event.target.querySelectorAll('[data-size-guide-open]').forEach(initSizeGuide);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
